import {
  get_all_industries,
  get_brochures_by_offer_id,
  get_location_by_ip,
  get_offers_by_company_id,
  post_user_tracking,
} from "../../API/dataProvider";
import React, { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  industriesAtom,
  nextOfferAtom,
  offersAtom,
  similarOffersAtom,
  slideLoaderAtom,
  sliderBrochuresAtom,
  toggleSliderAtom,
  userLocationAtom,
  UUIDAtom,
} from "../../Recoil/Atom";
import OfferCard from "../../Components/OfferCard";
import Search from "../../Components/Search";
import CarouselSlider from "../../Components/Slider";
import Loader from "../../Components/Loader";
import { useLocation, useNavigate } from "react-router-dom";
import OffersByCategory from "../../Components/OffersByCategory";
import profitalLogo from "../../../src/images/profital-logo.png";
import NoOfferCard from "../../Components/NoOfferCard";
import { Config, TrackingType } from "../../config";
import { v4 as uuidv4 } from "uuid";
import { StoreUUID } from "../../helper";
import OtherOffer from "../../Components/OtherOffer";

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function App() {
  const [searchResult, setSearchResult] = useState([]);
  const [searchString, setSearchString] = useState("");
  const toggleSlider = useRecoilValue(toggleSliderAtom);
  const slideLoader = useRecoilValue(slideLoaderAtom);
  const [loader, setLoader] = useState(false);
  const setSliderBrochures = useSetRecoilState(sliderBrochuresAtom);
  const setToggleSlider = useSetRecoilState(toggleSliderAtom);
  const setSimilarOffers = useSetRecoilState(similarOffersAtom);
  const setNextOffer = useSetRecoilState(nextOfferAtom);
  const location = useLocation();
  let query = useQuery();
  const [allCategories, setAllCategories] = useRecoilState(industriesAtom);
  const [searchLoader, setSearchLoader] = useState(false);
  const [count, setCount] = useState([]);
  const offer = useRecoilValue(offersAtom);
  const [userLocation, setUserLocation] = useRecoilState(userLocationAtom);
  const [UUID, setUUID] = useRecoilState(UUIDAtom);
  const [latestOffer, setLatestOffer] = useState({
    industry_id: 0,
    id: 0,
    title: "Neuste Prospekte",
  });
  const navigate = useNavigate();
  var brochureId = Number(query.get("id"));

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        let location = {
          location: {
            lat: position.coords.latitude,
            lon: position.coords.longitude,
          },
        };
        get_all_industries().then((data) => {
          setAllCategories(data);
          setUserLocation(location);
        });
      },
      (err) => {
        get_location_by_ip().then((location) => {
          get_all_industries().then((data) => {
            setAllCategories(data);
            setUserLocation(location);
          });
        });
      }
    );
    setUUID(StoreUUID(uuidv4()));
    document.addEventListener("keydown", callback, false);
  }, []);

  const callback = (event) => {
    if (event.key === "Escape") {
      navigate(`${Config.brochure_route}`, { replace: false });
      setToggleSlider(false);
    }
  };

  useEffect(() => {
    if (UUID && userLocation) {
      showSliderByURL();
      post_user_tracking(
        TrackingType.SCREEN_VIEW,
        undefined,
        undefined,
        userLocation,
        undefined,
        UUID,
        window.location.href,
        undefined,
        brochureId ? "brochure_detail" : "home_fallback",
        uuidv4()
      );
    }
  }, [location, UUID, userLocation]);

  const handleSearchInput = (e) => {
    let string = e.target.value;
    setSearchString(string);
    setSearchLoader(true);
    get_offers_by_company_id(null, null, string)
      .then((data) => {
        setSearchResult(data.data);
        setSearchLoader(false);
      })
      .catch(() => {
        setSearchLoader(false);
      });
  };

  const showSliderByURL = () => {
    // let brochureId = Number(query.get("id"));
    if (brochureId) {
      setLoader(true);
      setToggleSlider(false);
      get_brochures_by_offer_id(brochureId)
        .then((data) => {
          data.brochures.map((item) => {
            return (item.track_UUID = uuidv4());
          });
          setSliderBrochures(data);
          setNextOffer(data.next_offer);
          if (data?.offer?.industry_id) {
            get_offers_by_company_id(1, data?.offer?.industry_id)
              .then((data) => {
                setSimilarOffers(data.data);
                setLoader(false);
                setToggleSlider(true);
              })
              .catch(() => {
                setSimilarOffers([]);
                setLoader(false);
              });
          } else {
            setLoader(false);
            setToggleSlider(true);
          }
        })
        .catch(() => {
          setSliderBrochures([]);
          setLoader(false);
        });
    }
  };

  useEffect(() => {
    if (
      count.length == allCategories?.categories?.length &&
      allCategories?.categories.length != 0
    ) {
      let offer_obj = [];
      offer.forEach((item) => {
        offer_obj.push({
          id: item,
          track_UUID: uuidv4(),
        });
      });
      post_user_tracking(
        TrackingType.BROCHURE_IMPRESSION,
        { object: offer_obj },
        undefined,
        userLocation,
        undefined,
        UUID,
        window.location.href
      );
    }
  }, [count]);

  return (
    <>
      <main className="text-dark max-w-[1200px] mx-auto pb-10 xl:pb-20">
        {/* page header */}
        {slideLoader || loader ? (
          <Loader loaderStyle="fullScreenLoader" />
        ) : null}
        <div className="mb-12">
          <div className="mb-12 text-center">
            <h1 className="mb-4 text-2xl font-bold md:mb-6 md:text-3xl">
              Prospekte
            </h1>
            <p className="text-sm md:text-base">
              Hier findest du die aktuellsten Prospekte der Schweiz.
            </p>
          </div>

          <div className="w-[600px] max-w-full mx-auto">
            <Search
              handleSearchInput={handleSearchInput}
              setSearchLoader={setSearchLoader}
            />
          </div>
        </div>
        {/* End page header */}

        {searchString.length > 0 ? (
          <>
            <div
              id="brochure-grid"
              className="grid grid-cols-2 gap-4 mb-6 md:mb-10 sm:grid-cols-3 lg:grid-cols-4 md:gap-6 lg:gap-7"
            >
              {searchResult.map((item, index) => {
                return <OfferCard key={index} item={item} loader={loader} />;
              })}
            </div>
            {searchResult.length <= 0 && !searchLoader ? (
              <NoOfferCard
                title={"Leider keine Prospekte gefunden"}
                desc={
                  "Wir hoffen, dass wir dir bald einen Prospekt des gewünscht Händler zeigen können"
                }
              />
            ) : null}
          </>
        ) : null}

        {toggleSlider ? (
          <div className="fixed inset-0 z-[100000000] w-full min-h-screen text-white bg-dark slider-wrapper bg-opacity-90">
            {" "}
            <CarouselSlider />
          </div>
        ) : null}
        {!searchString.length ? (
          <OffersByCategory key={"kk"} item={latestOffer} index={null} />
        ) : null}
        {allCategories?.categories?.length > 0 &&
        searchString <= 0 &&
        !searchLoader ? (
          <div className="space-y-6 lg:space-y-10">
            {allCategories?.categories?.map((item, index) => {
              return (
                <OffersByCategory
                  key={index.toString()}
                  item={item}
                  setCount={setCount}
                  index={index}
                />
              );
            })}
          </div>
        ) : null}
        {!searchString.length ? <OtherOffer /> : null}
        {searchLoader ? <Loader /> : null}
      </main>
      {/* <div
        className="text-center bg-[rgba(234,234,234,0.4)] py-10 hover:cursor-pointer"
        onClick={() => {
          window.open(Config.profital_url, "_blank");
        }}
      >
        <img
          className="mx-auto mb-2 max-h-4"
          src={`${Config.app_url}/wp-content/uploads/2022/04/profital-logo.png`}
          alt="profital logo"
        />
        <p className="text-sm">In Zusammenarbeit mit Profital</p>
      </div> */}
    </>
  );
}

export default App;
